export enum PaymentBase {
  CONTRACT = 'CONTRACT',
  SURCHARGE = 'SURCHARGE',
  CLIENT = 'CLIENT',
  BOOKING = 'BOOKING'
}
